export default {
    liveData: [],
    validators: [],
    lists: [],
	forms: [],
    formButton: {},
    sections: [],
    fields: [],
    baseFields: [],
	activeField: [],
    editingSection: false,
    editingButton: false,
    conditioners: [],
    activeSection: [],
    activeSectionTagName: null,
	activeTabForFields: 'templated_sections'
}
